import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { WintSuperkollAPIModelSurveys } from "wint-api-client/dist/types";
import { SurveyCommentsListProps } from "models/propTypes/annualAccountPropTypes";
import { User } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import { CommentsView } from "components/common";
import { useSurveyService } from "serviceHooks";
//#endregion

const SurveyCommentsList: ForwardRefRenderFunction<FormHandles, SurveyCommentsListProps> = (props, ref) => {
  const surveyService = useSurveyService();
  const loggedInUser = useSelector((state: AppState) => state.auth.loggedInUser);
  const { surveyId, comments, reloadSurvey } = props;
  const [surveyComments, setSurveyComments] = React.useState<WintSuperkollAPIModelSurveys.SurveyComment[] | undefined>(
    comments
  );

  const commentHandler = (message: string) => {
    return new Promise<void>((resolve, reject) => {
      surveyService.addSurveyComment(surveyId, message).then((comment) => {
        if (surveyComments) {
          comment.createdByName = loggedInUser.name;
          comment.createdById = loggedInUser.personId;
          const updatedComments = [comment, ...surveyComments].sort((a, b) => (a.created > b.created ? 1 : -1));
          setSurveyComments(updatedComments);
          reloadSurvey && reloadSurvey(updatedComments);
          resolve();
        } else reject();
      });
    });
  };

  return (
    <CommentsView
      parentId={surveyId ?? ""}
      totalComments={surveyComments?.length}
      comments={surveyComments?.map((message, index) => ({
        id: index,
        parentId: Number(message.id),
        message: message.message ?? "",
        from: new User(message.createdById, message.createdByName),
        date: message.created,
        isAutomatic: message.createdById === undefined,
      }))}
      defaultViewCount={2}
      viewCountIncreaseBy={10}
      addCommentHandler={!props.readonly ? commentHandler : undefined}
      defaultExpanded
    />
  );
};

export default forwardRef(SurveyCommentsList);
